import { useLocationsRetrieve } from "@sidegigllc/api/client";
import { useIsAdmin, useUserRoleForLocation, useUserRoleForOrganization } from "domains/auth";

/** Qwick staff and the location's or organization's admins. The API refuses the plan to everyone else. */
export const useCanManageJobsPlan = (locationId: number | undefined): boolean => {
  const { data: location } = useLocationsRetrieve(locationId ?? -1, { query: { enabled: !!locationId } });
  const isStaff = useIsAdmin();
  const locationRole = useUserRoleForLocation(locationId ?? -1);
  const organizationRole = useUserRoleForOrganization(location?.organization_id ?? "");
  return isStaff || locationRole === "ADMIN" || organizationRole === "ADMIN";
};
